import React, { Component } from "react";
import PropTypes from "prop-types";
import _ from "lodash";
import { Table,Label } from "semantic-ui-react";
import accounting from 'accounting';
import InventoryOnOrderToolTips from '../utils/others/InventoryOnOrderToolTips';

class OrderLineView extends Component {
    getAvailable = () => {
        const {warehouseId} = this.props;
        const {qty_warehouse_instock, qty_warehouse_reserved} = this.props.line.inventory;
        let reserved = 0;
        let instock = 0;
        if (_.isArray(qty_warehouse_instock)) {
            _.each(qty_warehouse_instock, instockRecord => {
                if (_.toInteger(warehouseId) === _.toInteger(instockRecord.warehouse_id)) {
                    instock = _.toInteger(instockRecord.instock);
                }
            });
        }
        if (_.isArray(qty_warehouse_reserved)) {
            _.each(qty_warehouse_reserved, reservedRecord => {
                if (_.toInteger(warehouseId) === _.toInteger(reservedRecord.warehouse_id)) {
                    reserved = Math.abs(_.toInteger(reservedRecord.reserve));
                }
            });
        }

        return instock - reserved;
    }
    
    render() {
        const {line, jwt} = this.props;
        const {inventory} = line;
        return (
            <Table.Row>
                <Table.Cell>
                    <InventoryOnOrderToolTips
                        id={inventory.id}
                        name={inventory.sku}
                        jwt={jwt}
                        refId={`inventory-on-order-tooltip-${line.id}`}
                    />
                    {line.special_sku ? ` (${line.special_sku})`: null}
                </Table.Cell>
                <Table.Cell>
                    {inventory.name}
                    {line.special_name ? ` (${line.special_name})`: null}
                    &nbsp;&nbsp;
                    {inventory.type !== 'Inventory' ? <Label size='tiny' color='purple'>{inventory.type}</Label> : null}
                </Table.Cell>
                <Table.Cell>
                    {line.uom}
                </Table.Cell>
                <Table.Cell>
                    {Math.abs(line.quantity)}
                </Table.Cell>
                <Table.Cell>
                    {inventory.type === 'Inventory' ? this.getAvailable() : 'NA'}
                </Table.Cell>
                <Table.Cell>
                    {/* {line.price} */}
                    {Math.round(line.price * 100) / 100}
                </Table.Cell>
                <Table.Cell>
                    {inventory.type === 'Inventory' ? line.processed ? Math.abs(line.processed) : 0 : 'NA'}
                </Table.Cell>
                <Table.Cell>
                    {accounting.formatMoney(_.toInteger(line.quantity) * _.toNumber(line.price))}
                </Table.Cell>
            </Table.Row>
        );
    }
}

OrderLineView.propTypes = {
    line: PropTypes.shape({
        inventory: PropTypes.object.isRequired
    }).isRequired,
    warehouseId: PropTypes.string.isRequired,
    jwt: PropTypes.string.isRequired
};

export default OrderLineView;



// WEBPACK FOOTER //
// ./src/components/orders/OrderLineView.js